/**
 * Normalización de IDs y payload de detalle de producción.
 * ID canónico de navegación: doc.id de Firestore (nunca numero_orden).
 */

export function normalizarOrdenProduccion(orden, fallbackDocId) {
  if (!orden || typeof orden !== 'object') {
    return null;
  }

  const docId = orden.id || orden.docId || orden.orden_id || fallbackDocId || null;
  if (!docId) {
    return null;
  }

  const numero = orden.numero || orden.numero_orden || orden.codigo || null;

  return {
    ...orden,
    id: String(docId),
    numero
  };
}

export function normalizarDetalleProduccion(payload, fallbackDocId) {
  if (!payload || typeof payload !== 'object') {
    return { orden: null, receta: null, ingredientes: [], producto: null };
  }

  let source = payload;
  if (!source.orden && source.data && typeof source.data === 'object') {
    source = source.data;
  }

  return {
    orden: normalizarOrdenProduccion(source.orden, fallbackDocId),
    receta: source.receta || null,
    ingredientes: Array.isArray(source.ingredientes) ? source.ingredientes : [],
    producto: source.producto || null
  };
}

export function resolverDocIdOrden(orden, fallbackDocId) {
  const normalizada = normalizarOrdenProduccion(orden, fallbackDocId);
  return normalizada?.id || null;
}

/**
 * Mensaje UX para cambio de estado (POS-PROD-ERR-001).
 * Usa message/code del backend cuando es seguro; genérico si es 500.
 */
export function mensajeErrorCambioEstado(error) {
  const data = error?.response?.data || error?.data || {};
  const status = error?.response?.status || error?.status || data?.statusCode;
  const code = data?.code || data?.error;
  const backendMessage = typeof data?.message === 'string' ? data.message.trim() : '';

  if (code === 'STOCK_INSUFICIENTE') {
    return backendMessage || 'No hay stock suficiente para completar esta orden.';
  }
  if (code === 'ORDEN_YA_COMPLETADA') {
    return backendMessage || 'La orden ya fue completada.';
  }
  if (code === 'ORDEN_CANCELADA' || code === 'TRANSICION_INVALIDA') {
    return backendMessage || 'No se puede cambiar el estado de esta orden.';
  }
  if (code === 'RECETA_REQUERIDA' || code === 'RECETA_NO_ENCONTRADA') {
    return backendMessage || 'Falta configurar la receta de la orden.';
  }
  if (code === 'PRODUCTO_REQUERIDO') {
    return backendMessage || 'Falta configurar el producto terminado de la orden.';
  }
  if (code === 'SUCURSAL_REQUERIDA') {
    return backendMessage || 'La orden no tiene sucursal asignada.';
  }
  if (status === 403 || code === 'FORBIDDEN') {
    return 'No tenés permiso para completar órdenes de producción.';
  }
  if (status === 404 || code === 'ORDEN_NO_ENCONTRADA') {
    return backendMessage || 'Orden de producción no encontrada.';
  }
  if (status && status >= 400 && status < 500 && backendMessage) {
    return backendMessage;
  }
  return 'No pudimos completar la orden. Intentá nuevamente.';
}
